import Color from 'color';

import { BgColorTypes, CardItemTypes, ICard } from 'types/card';
import { ISanitizedCompany } from 'types/company';

import { DEFAULT_CARD_BG_GRADIENTS, theme } from 'constants/theme';

import { getCardTextItem } from 'services/cardItems';
import { getShortUniqueId } from 'services/uniqueId';

const DEFAULT_SOLID_COLOR = '#ffffff';

export const isDarkCard = (card: ICard) => {
  const cardBackground = card.background.colors.split(',')[0];
  return new Color(cardBackground).isDark();
};

export const cardsFactory = ({
  order,
  colors,
}: {
  order: number;
  colors?: string;
}): ICard => {
  const id = getShortUniqueId();

  return {
    id,
    meta: {
      order,
    },
    background: {
      type: BgColorTypes.SOLID,
      colors: colors || DEFAULT_SOLID_COLOR,
    },
    items: [],
  };
};

export const defaultCardsFactory = ({
  company,
}: {
  company: ISanitizedCompany;
}) => {
  const [bg] =
    company.theming?.gradients && company.theming?.gradients.length > 0
      ? company.theming?.gradients
      : company.theming?.colors && company.theming?.colors.length > 0
      ? company.theming?.colors
      : DEFAULT_CARD_BG_GRADIENTS;

  const color = new Color(bg.split(',')[0]).isDark()
    ? theme.colors.white
    : theme.colors.mineShaftGrey;

  return [
    {
      id: getShortUniqueId(),
      background: {
        colors: bg,
        type: BgColorTypes.LINEAR_GRADIENT,
      },
      meta: { order: 0 },
      items: [
        getCardTextItem({
          order: 0,
          top: '25%',
          itemType: CardItemTypes.STORY_TITLE,
          textType: 'headline',
          content: 'Story Title',
          color,
          fontSize: 120,
          fontWeight: 'bold',
        }),
        getCardTextItem({
          order: 1,
          top: '40%',
          itemType: CardItemTypes.STORY_DESCRIPTION,
          textType: 'paragraph',
          content: 'Short & attention-\ngrabbing subtitle',
          color,
          fontSize: 60,
          fontWeight: 'normal',
        }),
      ],
    },
    {
      id: getShortUniqueId(),
      background: {
        colors: bg,
        type: BgColorTypes.LINEAR_GRADIENT,
      },
      meta: { order: 1 },
      items: [
        getCardTextItem({
          order: 0,
          top: '25%',
          itemType: CardItemTypes.TEXT,
          textType: 'headline',
          content: 'Beginning of\nyour story',
          color,
          fontSize: 120,
          fontWeight: 'bold',
        }),
        getCardTextItem({
          order: 1,
          top: '45%',
          itemType: CardItemTypes.TEXT,
          textType: 'paragraph',
          content:
            'Keep it clear, make it short & use media or interactive elements',
          color,
          fontSize: 60,
          fontWeight: 'normal',
        }),
      ],
    },
  ];
};
